
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/freewheel-data-suite",
      function () {
        return require("private-next-pages/destinations/freewheel-data-suite.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/freewheel-data-suite"])
      });
    }
  